export const LISTS = 'LISTS';
export const GENERAL_ERRORS = 'GENERAL_ERRORS';
export const LIST = 'LIST';
export const OPTIONS = 'OPTIONS';
export const MAPPINGS = 'MAPPINGS';
export const NEW_FIELD_VISIBILITY = 'NEW_FIELD_VISIBILITY';
export const RESET = 'RESET';
